import React from "react";
import PropTypes from "prop-types";
import { Dialog } from "@progress/kendo-react-dialogs/dist/es/Dialog";
import "./paymentModal.css";
import controls from "../../controls";
import cart from "../../cart";
import StripeCheckoutStep from "./StripeCheckoutStep";

const {
  components: { CartContentsContainer: CartContents },
} = cart;

const {
  components: { Button },
} = controls;

const PaymentModal = ({
  dialogIsVisible,
  cancelPayment,
  noCartBalance,
  handleSubmit,
}) => (
  <div>
    {dialogIsVisible && (
      <Dialog className="payment-modal" onClose={cancelPayment}>
        {!noCartBalance && (
          <>
            <CartContents />
            <StripeCheckoutStep />
          </>
        )}
        {noCartBalance && (
          <>
            <CartContents />
            <div className="row mt-gutter">
              <div className="col">
                <Button
                  primary={false}
                  disabled={false}
                  text="Cancel"
                  onClick={cancelPayment}
                  width="100%"
                />
              </div>
              <div className="col">
                <Button
                  primary={true}
                  disabled={false}
                  text="Submit to IRS"
                  onClick={handleSubmit}
                  width="100%"
                />
              </div>
            </div>
          </>
        )}
      </Dialog>
    )}
  </div>
);

PaymentModal.propTypes = {
  dialogIsVisible: PropTypes.bool.isRequired,
  cancelPayment: PropTypes.func.isRequired,
  noCartBalance: PropTypes.bool,
  handleSubmit: PropTypes.func,
};

export default PaymentModal;
